import {
  CurrencyValue,
  Flex,
  formatNumber,
  BarChart,
  formatDatetime
} from '@blockanalitica/ui';
import { useMemo, useCallback } from 'react';
import { useTheme } from 'styled-components';
import { useChartPeriod } from '@/hooks';

export default function HistoricTabs({ data, timeFilter, chartDaysAgo }) {
  const theme = useTheme();
  const [chartPeriod, updateChartConfigWithPeriod] =
    useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();

  const volumeDatasets = useMemo(() => {
    return [
      {
        xField: 'date',
        yField: 'staked_volume',
        label: 'Staked',
        backgroundColor: theme.colors.chartUp
      },
      {
        xField: 'date',
        yField: 'withdraw_volume',
        label: 'Withdraw',
        backgroundColor: theme.colors.chartDown
      }
    ];
  }, [theme.colors]);

  const yScaleValueFormatter = useMemo(() => {
    return (value) => {
      return `${formatNumber(value)}`;
    };
  }, []);

  const subValueFormatter = useCallback(
    (value: string) => (
      <>
        {chartPeriod.labelPrefix}
        {formatDatetime(value, { format: chartPeriod.dateFormat })}
      </>
    ),
    [chartPeriod]
  );

  return (
    <Flex flexDirection="column" gap="xs">
      <BarChart
        key={'volume'}
        data={data}
        datasets={volumeDatasets}
        valueFormatter={(value) => (
          <CurrencyValue
            value={Number(value)}
            options={{
              currency: {
                name: data[0].staking_token_symbol,
                address: data[0].staking_token_address
              },
              iconSize: '-1'
            }}
          />
        )}
        yScaleValueFormatter={yScaleValueFormatter}
        timeFilter={timeFilter}
        config={config}
        subValueFormatter={subValueFormatter}
      />
    </Flex>
  );
}
